import axios from 'axios';
import { urlAPI } from '../../configurations/constantes';
import { MesEnum } from '../../enums';
import {
    RESET_STATE,

    LISTAGEM_FATURAMENTO_LOADING,
    LISTAGEM_FATURAMENTO,
    LISTAGEM_FATURAMENTO_ERRO,

    LISTAGEM_DETALHAMENTO_FATURAMENTO_LOADING,
    LISTAGEM_DETALHAMENTO_FATURAMENTO,
    LISTAGEM_DETALHAMENTO_FATURAMENTO_ERRO,

    DETALHAMENTO_FATURAMENTO_LOADING,
    DETALHAMENTO_FATURAMENTO,
    DETALHAMENTO_FATURAMENTO_ERRO
} from '../types/FaturamentoType';

export const resetarStateFaturamento = () => {
    return (dispatch) => {
        dispatch({
            type: RESET_STATE
        });
    }
};

export const obterListagemFaturamento = () => {
    return (dispatch) => {
        dispatch({
            type: LISTAGEM_FATURAMENTO_LOADING,
            payload: true
        });

        const ud = JSON.parse(localStorage.getItem('user_data'));

        axios.get(`${urlAPI}/cust/${ud.codigoEmpresa}/faturas`)
            .then((response) => {
                dispatch({
                    type: LISTAGEM_FATURAMENTO,
                    payload: response.data
                });
            })
            .catch((error) => {
                dispatch({
                    type: LISTAGEM_FATURAMENTO_ERRO,
                    payload: error
                });
            });
    }
};

export const obterListagemDetalhamentoFaturamento = () => {
    return (dispatch) => {
        dispatch({
            type: LISTAGEM_DETALHAMENTO_FATURAMENTO_LOADING,
            payload: true
        });

        const ud = JSON.parse(localStorage.getItem('user_data'));

        axios.get(`${urlAPI}/cust/${ud.codigoEmpresa}/faturas/periodo`)
            .then((response) => {
                const { primeiroFaturamento, ultimoFaturamento } = response.data;
                const lista = [];

                if (primeiroFaturamento && ultimoFaturamento) {
                    var mesInicio = new Date(primeiroFaturamento).getMonth() + 1;
                    var anoInicio = new Date(primeiroFaturamento).getFullYear();
                    const mesFim = new Date(ultimoFaturamento).getMonth() + 1;
                    const anoFim = new Date(ultimoFaturamento).getFullYear();

                    while (anoInicio <= anoFim) {
                        lista.push({
                            ano: anoInicio,
                            mes: mesInicio,
                            titulo: `${MesEnum.properties[mesInicio].nomeAbreviado}/${anoInicio.toString().substr(-2)}`,
                            detalhamento: null
                        });

                        if (mesInicio === 12) {
                            mesInicio = 1;
                            anoInicio++;
                        }
                        else
                            mesInicio++;

                        if (anoInicio === anoFim && mesInicio > mesFim)
                            break;
                    }
                }

                dispatch({
                    type: LISTAGEM_DETALHAMENTO_FATURAMENTO,
                    payload: lista
                });
            })
            .catch((error) => {
                dispatch({
                    type: LISTAGEM_DETALHAMENTO_FATURAMENTO_ERRO,
                    payload: error
                });
            });
    }
};

export const obterDetalhamentoFaturamento = (ano, mes) => {
    return (dispatch) => {
        dispatch({
            type: DETALHAMENTO_FATURAMENTO_LOADING,
            payload: true
        });

        const ud = JSON.parse(localStorage.getItem('user_data'));

        axios.get(`${urlAPI}/cust/${ud.codigoEmpresa}/faturas/detalhado`, {
            params: {
                mesReferencia: mes, anoReferencia: ano
            }
        }).then((response) => {
            dispatch({
                type: DETALHAMENTO_FATURAMENTO,
                payload: {
                    ano,
                    mes,
                    faturamento: response.data
                }
            });
        }).catch((error) => {
            dispatch({
                type: DETALHAMENTO_FATURAMENTO_ERRO,
                payload: error
            });
        });
    }
};